export default "__VITE_ASSET__70007773__"